<template>
  <div class="card">
    <div class="card-header">
      <h4>Aktivierungs Mails Senden</h4>
    </div>
    <div class="card-body">
      <fg-input label="Registrierung Von">
        <el-date-picker
          type="date"
          value-format="yyyy-MM-dd"
          format="dd.MM.yyyy"
          v-model="from"
          @input="getAffectetMemberAmount()"
        >
        </el-date-picker>
      </fg-input>
      <fg-input label="Registrierung Bis">
        <el-date-picker
          type="date"
          value-format="yyyy-MM-dd"
          format="dd.MM.yyyy"
          v-model="to"
          @input="getAffectetMemberAmount()"
        >
        </el-date-picker>
      </fg-input>
      <div>Unverifizierte Member {{ memberCount }}</div>
    </div>
    <div class="card-footer">
      <button @click="send" class="btn btn-primary">Emails Senden</button>
    </div>
  </div>
</template>

<script>
import { DatePicker } from "element-ui";
import { FgInput } from "src/components/UIComponents";
import moment from "moment";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [FgInput.name]: FgInput
  },
  created() {
    this.from = moment()
      .subtract(5, "days")
      .format("Y-M-D");
    this.to = moment().format("Y-M-D");
    this.getAffectetMemberAmount();
  },
  data() {
    return {
      from: "",
      to: "",
      memberCount: 0
    };
  },
  methods: {
    getAffectetMemberAmount() {
      this.$http
        .post("/api/v1/admin-actions/count-verification-email", {
          from: this.from,
          to: this.to
        })
        .then(({ data }) => (this.memberCount = data));
    },
    send() {
      this.$http
        .post("/api/v1/admin-actions/send-verification-email", {
          from: this.from,
          to: this.to
        })
        .then(({ data }) =>
          this.$notify({
            type: "success",
            title: `${data} Emails Versendet`
          })
        );
    }
  }
};
</script>

<style></style>
